import api from './api'
import notify from "@/utils/notify";

export default {
  async getSupplierPayments(params) {
    const data = {
      method: 'get',
      url: 'supplier-payments',
      params: params,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async getPurchasePayments(purchaseId, params) {
    const data = {
      method: 'get',
      url: `purchase/${purchaseId}/payments`,
      params: params,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async getSupplierPaymentsBySupplier(supplierId, params) {
    const data = {
      method: 'get',
      url: `supplier/${supplierId}/payments`,
      params: params,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async createSupplierPayment(json) {
    const data = {
      method: 'post',
      url: 'supplier-payment',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Supplier payment created', 2000)
      return response.data
    }
  },

  async getSupplierPayment(id) {
    const data = {
      method: 'get',
      url: 'supplier-payment/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async updateSupplierPayment(json, id) {
    const data = {
      method: 'put',
      url: 'supplier-payment/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier payment updated', 2000)
      return response.data
    }
  },

  async deleteSupplierPayment(id) {
    const data = {
      method: 'delete',
      url: 'supplier-payment/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier payment deleted', 2000)
      return true
    }
  },

  async approveSupplierPayment(id) {
    const data = {
      method: 'patch',
      url: 'supplier-payment-approve/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier payment approved', 2000)
      return response.data
    }
  },

  async getSupplierPaymentNextNo() {
    const data = {
      method: 'get',
      url: 'supplier-paymentNextNo',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
}
